module.exports = __webpack_public_path__ + "assets/9c0284b0611764cedbceba534395ff3f.mp3";